module.exports = __webpack_public_path__ + "img/trunk_4x4_z16.60970344.svg";